module.exports = __webpack_public_path__ + "static/media/cu.72cb307a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cu.svg
// module id = 92
// module chunks = 0